import React from 'react';
import { IInputAttributes } from '@components/Webform/WebformContent/interfaces';

interface InterfaceSelectInputs {
  inputAttributes: IInputAttributes;
}

const Select: React.FC<InterfaceSelectInputs> = ({ inputAttributes }): any => {
  inputAttributes.type = 'select';
  if (inputAttributes.options) {
    return (
      <div>
        <label>{inputAttributes.title}</label>
        <select
          defaultValue=""
          id={inputAttributes.id}
          name={inputAttributes.name}
          onChange={inputAttributes.onChange}
        >
          <option disabled value="">
            {inputAttributes.lang === 'de'
              ? 'Wählen Sie ihre Option'
              : 'Sélectionnez votre option'}
          </option>
          {inputAttributes.options.map((option, index: number) => {
            return (
              <option key={`select-optn${index}`} value={option.value}>
                {option.title}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
};

export default Select;
